import Fetcher from 'libs/fetcher';

const fetcher = new Fetcher();

export async function getOrgRooms() {
  const { data, totalCount } = await fetcher.get({
    path: '/rooms/organization',
  });
  return { data, totalCount };
}

export async function getRoomById(id) {
  const data = await fetcher.get({
    path: `/rooms/${id}`,
  });
  return data;
}

export async function getPublicRoomById(id) {
  const data = await fetcher.get({
    path: `/rooms/${id}/public`,
  });
  return data;
}

export async function createRoom(createData) {
  const data = await fetcher.post({
    path: '/rooms',
    body: createData,
  });
  return data;
}

export async function createRoomView(id, viewData) {
  const data = await fetcher.post({
    path: `/rooms/${id}/view`,
    body: viewData,
  });
  return data;
}

export async function updateRoom(roomId, updateData) {
  const data = await fetcher.put({
    path: `/rooms/${roomId}`,
    body: updateData,
  });
  return data;
}

export async function updateRoomExistingInvestors(roomId, investors) {
  const data = await fetcher.put({
    path: `/rooms/${roomId}/investors`,
    body: investors,
  });
  return data;
}

export async function deleteRoom(id) {
  const data = await fetcher.delete({
    path: '/rooms',
    body: {
      id,
    },
  });
  return data;
}
